// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserQuickActions__quickActionLabel__N5iGY{display:flex;flex-direction:row}.UserQuickActions__quickActionLabel__N5iGY .UserQuickActions__part11Icon__ruKVQ{margin-left:auto;margin-right:0.5rem}
`, "",{"version":3,"sources":["webpack://./src/js/apps/part11/components/UserRow/UserQuickActions/UserQuickActions.scss"],"names":[],"mappings":"AAAA,2CACI,YAAa,CACb,kBAAmB,CAFvB,gFAKQ,gBAAiB,CACjB,mBAAoB","sourcesContent":[".quickActionLabel {\n    display: flex;\n    flex-direction: row;\n\n    .part11Icon {\n        margin-left: auto;\n        margin-right: 0.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quickActionLabel": `UserQuickActions__quickActionLabel__N5iGY`,
	"part11Icon": `UserQuickActions__part11Icon__ruKVQ`
};
export default ___CSS_LOADER_EXPORT___;
